module.exports = __webpack_public_path__ + "img/pd-img-body6.9f9d6bb4.png";